import styles from "./index.module.less";
import { CloseCircleFilled } from "@ant-design/icons";
import Image from "@/components/Image";

export default function BoardAvatar({ url, name, onClose }) {
  return (
    <div className={styles.boardAvatar}>
      <div className={styles.imgBox}>
        <Image alt={name} src={url} width={32} height={32} />
      </div>
      <div className={styles.boardName}>{name}</div>
      <CloseCircleFilled className={styles.closeBtn} onClick={onClose} />
    </div>
  );
}
